module.exports = __webpack_public_path__ + "img/PR.6a5d20a2.svg";